// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__J4+VI","title":"styles_title__-5sQ0","buttonWrap":"styles_buttonWrap__DacjL","listStyle":"styles_listStyle__VtQdZ"};